module.exports = __webpack_public_path__ + "assets/150595255665f193a87330436ae7016d.png";